// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.LoginRegister.ForgotPassword.View'
,	[
	    'c3_shoppingextensions_loginregister_forgotpassword.tpl',
		'C3.ShoppingExtensions.LoginRegister.ForgotPassword.Model',
		'Utils',
		'Backbone.FormView',
		'C3.ShoppingExtensions.LoginRegister.ForgotPassword.Confirmation.View',
		'GlobalViews.Message.View'
    ]
, function (
		c3_shoppingextensions_loginregister_forgotpassword_tpl,
		ForgotPasswordModel,
		Utils,
		BackboneFormView,
		ForgotPasswordConfirmationView,
		GlobalViewsMessageView
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_loginregister_forgotpassword_tpl

	,   modalClass: 'global-views-modal-small'	

	,   events: {
       			'submit form': 'submitForm',
       			'click [data-action="login-popup"]':'loginPopup'
    }

	,	bindings: {
			'[name="email"]': 'email'
		}

	,	initialize: function (options) {
			this.options = options;

			this.application = options.application
			this.layout = options.layout

			this.model = new ForgotPasswordModel();
        	this.model.on('save', _.bind(this.showSuccess, this));
           	BackboneFormView.add(this);
			
		}

	,   submitForm: function submitForm(e, model, props) {
		e.preventDefault();

        const self = this;
        const data = (jQuery(e.target).closest('form')).serializeObject();
       
        /*return this.cancelableTrigger('before:LoginRegisterExtension.forgotPassword', data).then(function() {
            self.saveForm(e, model, props);
        });*/
        const promise = this.saveForm(e, model);
        if (promise) {
            promise
            .fail(function(jqXhr) {
                //console.log(jqXhr)
                var response = jqXhr.responseJSON
                if(response.errorStatusCode === '400'){
                	var $alert_placeholder = self.$el.find('[data-type="forgotpassword-alert-placeholder"]')
                    //console.log(response.errorMessage);
                    const global_view_message = new GlobalViewsMessageView({
			            message: response.errorMessage,
			            type: 'error',
			            closable: false
			        });
                     $alert_placeholder.html(
			            global_view_message.render().$el.html()
			        );

                   	/*var mainContainer =  self.$containerModal.siblings()
                   	,   mainChilds = mainContainer.children('div#main-container')
                   	console.log(mainChilds.children('[data-type="alert-placeholder"]'))
                   	console.log(mainChilds.children().find('[data-type="alert-placeholder"]'))*/
                   	//console.log(mainContainer.children().find('div#main-container'))
                    //console.log(mainContainer.children().find('[data-type="alert-placeholder"]'))
                    this.error = null;
                    //self.showError(response.errorMessage, 'error', true);
                    //self.layout.showMessage($alert_placeholder, response.errorMessage, 'error', true);
                   //self.$el.find('[data-type="forgotpassword-alert-placeholder"]').html(response.errorMessage)
                }
            })
            .done(function(res) {
                console.log(res);
            })
        }
    }	


    ,   loginPopup: function loginPopup(e){
    			e.stopPropagation();
				e.preventDefault();
				jQuery('.dontshow-magic-link .dontshow-link').trigger('click',true);
    }

    ,   showSuccess: function showSuccess(context, response){
    			//debugger;
		    	var self = this;
		    	var Layout = this.application.getComponent('Layout');

		    	var view=new ForgotPasswordConfirmationView();
		    	Layout.showContent(view, {showInModal: true});		
    }

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			
			return {
				
			};
		}
	});
});
